<template>
  <div>
    <single-selection
      v-for="selection in singleSelections()"
      :key="selection.id"
      ref="single"
      :selection="selection"
      :category-name="categoryName"
      class="pb-3"
      @deleteSelection="deleteSelection(selection)"
      @onEnter="$emit('onEnter')"
    />
  </div>
</template>

<script>
import SingleSelection from './SingleSelection.vue';

export default {
  name: 'Selections',
  components: {
    'single-selection': SingleSelection,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    categoryName() {
      return `${this.category.name} ${this.category.translation ? `(${this.category.translation})` : ''}`;
    },
  },
  methods: {
    singleSelections() {
      return this.category.selections;
    },
    deleteSelection(selection) {
      this.category.selections = this.category.selections.filter(s => s !== selection);
    },
    focus() {
      this.$refs.single[this.$refs.single.length - 1].focus();
    },
    validate() {
      let valid = true;
      const refs = [...(this.$refs.single || [])];
      Object.values(refs).forEach(async (r) => {
        if (!r.validate()) {
          valid = false;
        }
      });

      return valid;
    },
  },
};
</script>

<style>
.list .input-group {
  margin-bottom: -8px;
}
</style>
